module.exports = [{"type":"title","text":"2023-08-23"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"現貨：新增 <a href='http://https://bingx-api.github.io/docs/#/spot/market-api.html#24%E5%B0%8F%E6%99%82%E5%83%B9%E6%A0%BC%E8%AE%8A%E5%8B%95%E6%83%85%E6%B3%81'  target='_blank'>24小時價格變動情況</a> 接口"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2023-08-23.json
// module id = bKtD
// module chunks = 3